module.exports = __webpack_public_path__ + "static/img/courtyardstone_landscape_logo.ab69f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courtyardstone_landscape_logo.png
// module id = 775
// module chunks = 2